/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrLocationType } from './irrLocationType';


export interface IrrLoggingConfig { 
    frequencySeconds?: number;
    locationType?: IrrLocationType;
    location?: string;
}
export namespace IrrLoggingConfig {
}


